<template>
	<div class="newsletter-analytics-wrapper">
		<div class="analytics-content">
			<AppTable
				ref="newsletters-stats-table"
				:fetch-function="newsletterStore.getFilteredNewslettersStats"
				:filters="filters"
				:table-headings="tableHeadings"
				:title="getString('newsletter_analytics')"
				:total-items="newsletterStore.newslettersStatsTotal || 0"
				:items="newsletterStore.newslettersStats"
				initial-sort-field="sent_date"
				:initial-sort-asc="false"
				:app-select-values="['10', '25', '50', '100']"
				@failed-fetch="handleFailedFetch"
			/>
		</div>
	</div>
</template>

<script>
import AppTable from "@/shared/components/AppTable.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useNewsletterStore} from "@/console-new/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const newsletterStore = useNewsletterStore();
		return {
			getString: languageStore.getString,
			showNotification: notificationStore.showNotification,
			newsletterStore
		};
	},
	name: "NewsletterAnalytics",
	components: {
		AppTable,
		ModalHeader
	},
	computed: {
		tableHeadings() {
			return [
				{
					text: this.getString('newsletter_name'),
					cols: 2,
					fieldName: 'subject',
					sortable: false
				},
				{
					text: this.getString('sent_date'),
					cols: 1,
					fieldName: 'sent_date',
					sortable: true,
					type: 'datetime'
				},
				{
					text: this.getString('delivered'),
					cols: 1,
					fieldName: 'sent',
					sortable: false
				},
				{
					text: this.getString('viewed'),
					cols: 1,
					fieldName: 'viewed_pct',
					sortable: false,
					suffix: '%'
				},
				{
					text: this.getString('clicked'),
					cols: 1,
					fieldName: 'clicked_pct',
					sortable: false,
					suffix: '%'
				},
				{
					text: this.getString('bounced'),
					cols: 1,
					fieldName: 'bounced',
					sortable: false
				}
			];
		},
		filters() {
			return [
				{
					type: "date",
					key: 'sent_date',
					tableName: 'businesses_newsletters',
					text: this.getString('sent_date'),
					finalValue: '',
					active: false
				}
			];
		}
	},
	methods: {
		handleFailedFetch(details) {
			this.showNotification('generic-error');
		}
	}
}
</script>

<style scoped lang="scss">
.newsletter-analytics-wrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
}

.analytics-content {
	flex: 1;
	overflow-y: auto;
}
</style>
